import {HeroTitle} from "@/pages/common/Home/components/HeroTitle";

import React, {useEffect, useState} from "react";

import adaptability from "@images/home/suit/adaptability.svg";
import circle from "@images/home/suit/circle.png";
import customer from "@images/home/suit/customer.svg";
import data from "@images/home/suit/data.svg";
import product from "@images/home/suit/product.svg";
import roi from "@images/home/suit/roi.svg";
import {motion} from "framer-motion";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

const itemAnimation = {
  hidden: {
    transform: `scale(0.6)`,
    opacity: 0,
  },
  visible: {
    transform: `scale(1)`,
    opacity: 1,
    transition: {delay: 0.3},
  },
};

const CircleItem = ({icon, title, subtitle, isActive, onClick}) => {
  const {isMobile} = useSelector((state) => state.common.settings);

  const handleClickItem = () => {
    if (isMobile) {
      onClick();
    }
  };

  useEffect(() => {
    if (!isMobile) {
      onClick(null);
    }
  }, [isMobile]);

  return (
    <article
      onClick={handleClickItem}
      className={styles.intro_circle_item}
    >
      <img
        src={icon}
        alt={"icon"}
      />

      {title}

      <i
        style={
          isActive
            ? {
                opacity: "1",
                pointerEvents: "all",
                visibility: "visible",
                zIndex: "20",
              }
            : {}
        }
      >
        {subtitle}
      </i>
    </article>
  );
};

export const Intro = () => {
  const [activeCard, setActiveCard] = useState(null);
  const {isMobile} = useSelector((state) => state.common.settings);

  const {t} = useTranslation();

  const circleItems = [
    {
      id: 0,
      icon: customer,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.title_1"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.desc_1"),
          }}
        />
      ),
    },
    {
      id: 1,
      icon: product,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.title_2"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.desc_2"),
          }}
        />
      ),
    },
    {
      id: 2,
      icon: adaptability,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.title_3"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.desc_3"),
          }}
        />
      ),
    },
    {
      id: 3,
      icon: data,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.title_4"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.desc_4"),
          }}
        />
      ),
    },
    {
      id: 4,
      icon: roi,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.title_5"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.circle.desc_5"),
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    if (!isMobile) {
      setActiveCard(null);
    } else {
      const handleClick = () => setActiveCard(null);
      document.addEventListener("mousedown", handleClick);

      return () => {
        document.removeEventListener("mousedown", handleClick);
      };
    }
  }, [isMobile]);

  return (
    <div className={styles.intro}>
      <HeroTitle>
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.intro_title"),
          }}
        />

        <span
          dangerouslySetInnerHTML={{
            __html: t("page.suit.intro_desc"),
          }}
        />
      </HeroTitle>

      <div className={styles.intro_bottom}>
        <p
          dangerouslySetInnerHTML={{
            __html: t("page.suit.since.desc"),
          }}
        />

        <motion.div
          initial={"hidden"}
          whileInView={"visible"}
          viewport={{amount: 0, once: true}}
          variants={itemAnimation}
          className={styles.intro_circle}
        >
          <div className={styles.intro_circle_image}>
            <img
              src={circle}
              alt={"circle"}
            />
          </div>

          <h3
            dangerouslySetInnerHTML={{
              __html: t("page.suit.since.circle.title_root"),
            }}
          />

          {circleItems &&
            circleItems.length > 0 &&
            circleItems.map((item, index) => (
              <React.Fragment key={item.id}>
                <CircleItem
                  icon={item.icon}
                  title={item.title}
                  subtitle={item.subtitle}
                  isActive={activeCard === index + 1}
                  onClick={() =>
                    setActiveCard(activeCard === index + 1 ? null : index + 1)
                  }
                />
              </React.Fragment>
            ))}
        </motion.div>
      </div>
    </div>
  );
};
